import { ReactNode, CSSProperties, Ref } from 'react'
import styles from './style'

interface TextProps {
  children?: ReactNode
  style?: CSSProperties
  title?: string
  ref?: Ref<HTMLDivElement>
}

function Text({ children, style = {}, title, ref }: TextProps) {
  return (
    <div
      ref={ref}
      title={title}
      style={{ ...styles.text, ...style }}
    >
      {children}
    </div>
  )
}

export default Text
